import React from "react";
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import StackhawkCredentialsForm from "./StackhawkCredentialsForm";
import StackhawkConfigListing from "./StackhawkConfigListing";

export default function StackhawkPullAndPushView(props){
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={StackhawkCredentialsForm}
            PullConfigListingView={StackhawkConfigListing}
        />
    )
}
